import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';
import { Field, LinkField, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';

export type C34InlineMediaCtaProps = RenderingProps<
  C34InlineMediaCtaFields,
  C34InlineMediaCtaParams,
  C34InlineMediaCtaPlaceholder
>;

export type C34InlineMediaCtaFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
  CTA?: LinkField;
};

export type C34InlineMediaCtaParams = {
  BackgroundColor?: string;
  ContentAlignment?: string;
  HeadlineTag?: string;
  Columns?: string;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export interface C34InlineMediaCtaPlaceholder {
  'inline-media-cta-cards-{*}'?: {
    componentName?: string;
  }[];
}
